"use client";
import "./MatchGoalLossRatio.scss";
import NoData from "@/components/client/NoData";
import CollapsiblePanel from "@/components/client/CollapsiblePanel";
import DataGoalLossRatio from "@/components/client/DataGoalLossRatio";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_white_leagues.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_white_leagues.svg";

const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES.src;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES.src;

export default function MatchGoalLossRatio({ match, status }) {
  if (!match) {
    return <NoData />;
  }

  return (
    <>
      <CollapsiblePanel
        title="Tỉ Lệ Ghi Mất Bàn "
        initOpen={true}
        iconUp={IMAGE_ARROW_UP_LEAGUES}
        iconDown={IMAGE_ARROW_DOWN_LEAGUES}
      >
        <DataGoalLossRatio match={match} status={status} />
      </CollapsiblePanel>
    </>
  );
}
